import { ref, unref } from 'vue'
import { router } from '@/router'
import { useGo } from '@/composables/usePage'
// import { getTagViews } from '@/utils/tagsView'

export type DetailIframe = { path: string; frameSrc: string }

const detailIframesRef = ref<DetailIframe[]>([])

// ;(() => {
//   const cachedViews = getTagViews() || []
//   cachedViews.forEach((item: any) => {
//     if (item.meta && item.meta.hideMenu) {
//       const matchRes = (item.meta.frameSrc || '').match(/[^?]+/)
//       const frameSrc = matchRes ? matchRes[0] : ''
//       detailIframesRef.value.push({
//         path: item.fullPath,
//         frameSrc: `${frameSrc}?${new URLSearchParams(item.query).toString()}`,
//       })
//     }
//   })
// })()

export function useDetailIframe() {
  const go = useGo(router)
  function parsePath(path: string) {
    return `/web/main${path.replace('/web', '').replaceAll('/', '-')}`
  }

  function addDetailIframe(path: string) {
    const iframes = unref(detailIframesRef)
    const parsedPath = parsePath(path)
    const found = iframes.find((item) => item.path === parsedPath)
    if (found === void 0) {
      const prefixURL = import.meta.env.DEV ? 'http://dev-wms-web.eminxing.com' : ''
      iframes.push({ path: parsedPath, frameSrc: `${prefixURL}${path}` })
    }
    go(parsedPath)
  }

  function removeDetailIframe(path: string) {
    const iframes = unref(detailIframesRef)
    const foundIndex = iframes.findIndex((item) => item.path === path)
    if (foundIndex > -1) {
      iframes.splice(foundIndex, 1)
    }
  }

  return {
    detailIframesRef,
    addDetailIframe,
    removeDetailIframe,
  }
}
